import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import IframeDocxPreview from '../../../ComponentOrder/PurchaseOrderList/PurchaseOrderDetail/AllRenderTable/IframeDocxPreview';
import { imageUrl } from '../../../../Components/helper';

function PreviewModal({ onOpen, toggle, data }) {
  const [state, setState] = useState([]);
  const { t } = useTranslation('common');
  const fileExtension = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  useEffect(() => {
    if (data?.mimeType === fileExtension) {
      const fetchExcelData = async () => {
        try {
          let fileUrl = data?.path;
          if (fileUrl?.includes('static')) {
            fileUrl = `${imageUrl}${data?.path.split('static')[1]}`;
          }
          const response = await fetch(fileUrl);

          const arrayBuffer = await response.arrayBuffer();
          const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

          const reader = new FileReader();

          reader.onload = (event) => {
            const binaryString = event.target.result;
            const workbook = XLSX.read(binaryString, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            setState(excelData);
          };

          reader.readAsBinaryString(blob);
        } catch (error) {
          console.error('Error fetching or parsing the file:', error);
        }
      };

      fetchExcelData();
    }
  }, [data?.path, data?.mimeType]);

  return (
    <>
      {data?.mimeType === fileExtension && (
        <Modal className="relative-width-modal custom-modal modal-medium" size="lg" show={onOpen} onHide={toggle} backdrop="static" centered>
          <Modal.Header>{data?.fileName}</Modal.Header>
          <Modal.Body className="px-5">
            {!data && <div className="text-center">{t('EDIT_FIELD_MODAL.NO_PREVIEW')}</div>}
            {state.length > 0 && (
              <>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead className="thead-dark">
                      <tr>
                        {Object.keys(state[0]).map((key) => (
                          <th key={key}>{key}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {state.map((row, index) => (
                        <tr key={index}>
                          {Object.values(row).map((cell, cellIndex) => (
                            <td key={cellIndex}>{cell}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="text-right mt-3">
                  <button className="btn btn-default" type="button" onClick={() => toggle()}>
                    {t('COSTING_TO_DO_LIST.CLOSE')}
                  </button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      )}

      {data?.mimeType !== fileExtension && data?.mimeType !== 'application/msword' && (
        <Modal className="relative-width-modal custom-modal modal-medium" size="lg" show={onOpen} onHide={toggle} backdrop="static" centered>
          <Modal.Header>{data?.fileName}</Modal.Header>
          <Modal.Body className="px-5">
            {!data && <div className=" text-center">{t('EDIT_FIELD_MODAL.NO_PREVIEW')}</div>}
            <iframe title={t('DEVLOPMENT_ORDER.PURCHASE_ORDER_DOCUMENT.PREVIEW_MODAL.PREVIEW_FRAME')} className="w-100 preview-modal-height" src={data?.path} />
            <div className="modal-buttons mt-2 d-flex justify-content-between">
              <button className="btn btn-default" type="button" onClick={() => toggle()}>
                {t('COSTING_TO_DO_LIST.CLOSE')}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}
      {data?.mimeType === 'application/msword' && (
        <Modal className="relative-width-modal custom-modal modal-medium" size="lg" show={onOpen} onHide={toggle} backdrop="static" centered>
          <Modal.Header>{data?.fileName}</Modal.Header>
          <Modal.Body className="px-5">
            <IframeDocxPreview docxUrl={data?.path} />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default PreviewModal;
